import Default from './default';
import Slider from '../components/slider';

class Home extends Default {
	namespace = 'home';

	beforeLeave = (data) => {
		super.beforeLeave(data);
	}

	afterLeave = (data) => {
		super.afterLeave(data);
	}

	beforeEnter = data => {
		const scope = data.next.container;
		super.beforeEnter(data);
		this.initSlider(scope);

		const intro = new IntroAnimation($(scope).find('[data-intro-animation="el"]'));
	};

	afterEnter = (data) => {
		super.afterEnter(data);
	}

	initSlider = (scope) => {
		const $sliders = $(scope).find('[data-slider="el"]');

		$sliders.each((i, el) => {
			new Slider($(el));
		});
	}
}

export default new Home();
